import { Trans } from '@lingui/macro';
import { get } from 'lodash';
import FormSection from '../../../form/FormSection';
import useNgpFormContext from '../../../../utilities/NgpFormContextProviderUtilities';
import useRecordContext from '../../../../utilities/RecordContextProviderUtilities';
import MonitoringDeviceDiagnosticsSection from './MonitoringDeviceDiagnosticsSection';

/**
 * Inline monitoring diagnostics section.
 * Shows ClassifierLogTable with contextual help messages.
 */
const DeviceMonitoringDiagnostics = () => {
    const { formData } = useNgpFormContext();
    const { id } = useRecordContext();

    const uiState = get(formData, 'uiState', '');
    const deviceType = get(formData, 'deviceType', '');

    return (
        <FormSection title={<Trans>Monitoring Diagnostics</Trans>} addSpacer>
            <MonitoringDeviceDiagnosticsSection id={id} uiState={uiState} deviceType={deviceType} showMessage={false} />
        </FormSection>
    );
};

export default DeviceMonitoringDiagnostics;
